// packages
import { entries } from 'd3-collection';
import cx from 'classnames';
import { h } from 'preact';

import { isCanvass } from '../endpoints';

// components
import CandidateRow from './CandidateRow';
import PureComponent from './PureComponent';

// internal
import formatPercent from '../utils/format-percent';

class TooltipTable extends PureComponent<any> {
  render() {
    const { candidatesMap, county, candidatesRender, source } = this.props;

    const sortedResults = entries(county.results).sort(
      (a, b) => b.value - a.value
    );

    const pct_votes =
      source == 'Decision Desk HQ'
        ? formatPercent(county.total_votes, county.estimated_votes_mid)
        : county.eevp;

    let contestMetricsClass = cx('contest__metrics', {
      contest__metrics__canvass: isCanvass == true,
    });

    const pct_votes_turnout =
      pct_votes < 100
        ? `An estimated ${pct_votes}% of votes counted`
        : `An estimated >99% of votes counted`;

    const firstThreeResults = sortedResults.slice(0, 3);

    return (
      <div class="contest">
        <table class="contest__candidates contest__candidates--tooltip">
          <caption>
            <p class="county__title">{county.county} County</p>
            <div class={contestMetricsClass}>
              {isCanvass == false && (
                <p class="contest__precincts">
                  {source != 'Associated Press' && source != 'Decision Desk HQ'
                    ? `${formatPercent(
                        county.county_pollinglocationsreporting,
                        county.total_county_pollinglocations
                      )}% reporting`
                    : pct_votes_turnout}
                </p>
              )}
            </div>
          </caption>
          {CandidateRow.countyHeader}
          <tbody>
            {firstThreeResults.map(result => {
              const candidate = candidatesMap.get(result.key);

              const candColor =
                county.total_votes > 0
                  ? candidatesRender.filter(cand => cand.name == candidate.name)
                  : '#EF564A';

              return (
                <CandidateRow
                  key={candidate.id}
                  ballotName={candidate.name}
                  candidateId={candidate.id}
                  contestIsCalled={false}
                  candidateColor={candColor[0]['color']}
                  isIncumbent={candidate.is_incumbent}
                  isWinner={candidate.is_winner}
                  isMapRow
                  party={candidate.party}
                  totalVotesInContest={county.total_votes}
                  votes={result.value}
                />
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }
}

export default TooltipTable;
